import Vue from 'vue';

Vue.component('billing-index', () =>
    import(/* webpackChunkName: 'billing-index' */ './billing-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/billing/index.js